export default {
  props: [
    {
      name: 'open',
      type: Boolean,
      default: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/mixins/ActsAsModal.js